import { DebugService } from '../debug/debug.service.js';

class _CookieService {
  constructor() {
    this.debug = new DebugService('CookieService');
  }

  getCookie(key) {
    return document.cookie
      ?.split('; ')
      ?.find(row => row.startsWith(key))
      ?.split('=')[1];
  }

  removeCookie(key) {
    if (this.getCookie(key)) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
  }

  // Strip cookie-structural characters (';', CR, LF)
  // to prevent malicious injection (CWE-93).
  // NOTE: Downstream servet Cookie API (host-app-bff) rejects
  // but we strip at write to explicitly remove injection vector
  sanitizeCookieComponent(input) {
    return String(input ?? '').replace(/[;\r\n]/g, '');
  }

  createOrUpdateCookie(key, value, secure, domain, maxAge, path) {
    const safeKey = this.sanitizeCookieComponent(key);
    const safeValue = this.sanitizeCookieComponent(value);
    document.cookie = `${safeKey}=${safeValue};domain=${domain};max-age=${maxAge};path=${path};${secure ? 'secure' : ''}`;
  }
}

export const CookieService = new _CookieService();
